export default __webpack_public_path__ + "static/media/previous_paper_analysis.580a89ea.png";